module.exports = "<p>\n  single-company-dashboard-page works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/onboarding/components/single-company-dashboard-page/single-company-dashboard-page.component.html
// module id = ./src/app/onboarding/components/single-company-dashboard-page/single-company-dashboard-page.component.html
// module chunks = main